// extracted by mini-css-extract-plugin
export default {"go_to_top":"go-top_go_to_top__MogiQ"};